import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Grid from "@mui/material/Grid2";
import {
  Button,
  Checkbox,
  Collapse,
  FormControlLabel,
  FormGroup,
  Autocomplete,
  TextField,
  Chip,
  Stack,
} from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import dayjs, { Dayjs } from "dayjs";

export type EventType = {
  type: 'Games' | 'Lessons' | 'Tournaments';
  color: 'primary' | 'secondary' | 'warning';
};

export const eventTypes: EventType[] = [
  { type: 'Games', color: 'primary' },
  { type: 'Lessons', color: 'secondary' },
  { type: 'Tournaments', color: 'warning' },
];

function FilterEvents({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  filterGames,
  showOnlyBookedLessons,
  setShowOnlyBookedLessons,
  selectedEventTypes,
  setSelectedEventTypes,
}: {
  startDate: string;
  endDate: string;
  setStartDate: Dispatch<SetStateAction<string>>;
  setEndDate: Dispatch<SetStateAction<string>>;
  filterGames: () => void;
  showOnlyBookedLessons: boolean;
  setShowOnlyBookedLessons: Dispatch<SetStateAction<boolean>>;
  selectedEventTypes: EventType[];
  setSelectedEventTypes: Dispatch<SetStateAction<EventType[]>>;
}) {
  const [showFilters, setShowFilters] = useState(false);

  const handleStartDateChange = (date: Dayjs | null) => {
    if (date) {
      setStartDate(date.format("YYYY-MM-DD"));
    }
  };

  const handleEndDateChange = (date: Dayjs | null) => {
    if (date) {
      setEndDate(date.format("YYYY-MM-DD"));
    }
  };

  return (
    <Stack spacing={2}>
      <Button
        variant="outlined"
        size="large"
        color="primary"
        startIcon={<FilterListIcon />}
        onClick={() => setShowFilters(!showFilters)}
        fullWidth
        sx={{ mb: showFilters ? 2 : 0 }}
      >
        Filters
      </Button>

      <Collapse in={showFilters}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6 }}>
            <DatePicker
              label="From"
              value={dayjs(startDate)}
              onChange={handleStartDateChange}
              slotProps={{
                textField: {
                  fullWidth: true
                }
              }}
            />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <DatePicker
              label="To"
              value={dayjs(endDate)}
              onChange={handleEndDateChange}
              slotProps={{
                textField: {
                  fullWidth: true
                }
              }}
            />
          </Grid>
          {/*<Grid size={{ xs: 4 }}>
            <Button
              variant="outlined"
              size="large"
              color="primary"
              onClick={() => {
                const newStartDate = moment().format("YYYY-MM-DD");
                const newEndDate = moment().add(4, "weeks").format("YYYY-MM-DD");
                setStartDate(newStartDate);
                setEndDate(newEndDate);
                filterGames();
              }}
              style={{ height: "100%" }}
              fullWidth
            >
              Reset
            </Button>
          </Grid>*/}
        </Grid>
        <Autocomplete
          multiple
          options={eventTypes}
          value={selectedEventTypes}
          onChange={(_, newValue) => setSelectedEventTypes(newValue)}
          getOptionLabel={(option) => option.type}
          getOptionDisabled={(option: EventType) =>
            selectedEventTypes.some(selected => selected.type === option.type)
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Event Types"
              //placeholder="Select event types"
            />
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                label={option.type}
                color={option.color}
                {...getTagProps({ index })}
              />
            ))
          }
          sx={{ mt: 2 }}
        />
        {selectedEventTypes.some(event => event.type === 'Lessons') && (
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showOnlyBookedLessons}
                  onChange={(event) => {
                    setShowOnlyBookedLessons(!showOnlyBookedLessons);
                  }}
                />
              }
              label="Only Show Booked Lessons"
            />
          </FormGroup>
        )}
      </Collapse>
    </Stack>
  );
}

export default FilterEvents;
